import React, {useState} from "react";
import {useLocation} from "react-router-dom";
import { Helmet } from "react-helmet";

import { Tab } from "../../../../components"
import {GET_APP_LOCALIZE_TEXT} from "../../../../utils/dq_lc_service/lc_service";
import styled from "styled-components/macro";
import {Box, Typography as MuiTypography} from "@material-ui/core";
import {spacing} from "@material-ui/system";
import BreakdownEfficacyTab from "../Tabs/BreakdownEfficacyTab.comp";

const Typography = styled(MuiTypography)(spacing);

const ColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.sidebar.background};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`

const DefaultColouredTypography = styled(Typography)`
  color: ${(props) => props.color ? props.color : props.theme.palette.tertiary.main};
  font-size: ${(props) => props.size ? props.size : "default"};
  font-family: "Lemon/Milk";
  font-weight: ${(props) => props.weight ? props.weight : "default"};
`

function BreakdownEfficacy() {

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];

    const [selectedTab, setSelectedTab] = useState(0);

    const TabsComponents = [
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__competency_acquisition") || "Competency Acquisition",
            data_key: "Acquisition",
            description: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__competency_acquisition_desc") || "Percentage of each demographic who have acquired one or more competences through the Program.",
        },
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__competency_improvement") || "Competency Improvement",
            data_key: "Improvement",
            description: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__competency_improvement_desc") || "Percentage of each demographic who have shown a significant improvement in one or more competences through the Program.",
        },
        {
            title: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__intention_for_change") || "Intention for change",
            data_key: "Intention",
            description: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__intention_for_change_desc") || "Percentage of each demographic who have shown the intention to positively change behaviour in one or more competences after completing the Program.",
        },
    ];

    const onChangeTab = (value) => {
        setSelectedTab(value);
    }

    return (
        <React.Fragment>
            <Helmet title={GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__enhancement_efficacy") || "Enhancement Efficacy"}/>
            <Box mx={"3vw"}>
                <Box mb={5}>
                    <DefaultColouredTypography variant="h2">
                        {GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__efficacy_breakdown_title") || "Efficacy Breakdown"}
                    </DefaultColouredTypography>
                    <ColouredTypography variant={"body1"} size={"16px"}>
                        {GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__efficacy_breakdown_desc") || "Understanding the user groups' enhancement from the program."}
                    </ColouredTypography>
                </Box>
                {
                    <Tab titles={TabsComponents.map((component) => component.title)} onChange={onChangeTab}>
                        {
                            TabsComponents.map((component, index) =>
                                <BreakdownEfficacyTab
                                    key={index}
                                    skill={component.data_key}
                                    title={component.title}
                                    description={component.description}
                                />
                            )
                        }
                    </Tab>
                }
            </Box>
        </React.Fragment>
    );
}

export default BreakdownEfficacy;
